import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import posthog from 'posthog-js';
import { forkJoin, of } from 'rxjs';
import { Complaint } from 'src/app/akita/complaints/state/complaint.model';
import { Log } from 'src/app/akita/contact-moments/state/log.model';
import { Issue } from 'src/app/akita/issues/state/issue.model';
import { Decision } from 'src/app/akita/requirements/state/decision.model';
import { Action } from 'src/app/akita/tasks/state/action.model';
import { DocumentsService } from 'src/app/core/service/api/documents.service';
import { LogsService } from 'src/app/core/service/api/logs.service';
import { PubsubService } from 'src/app/core/service/api/pubsub.service';
import { CachedService } from 'src/app/core/service/common/cached.service';
import { GenericComponent } from 'src/app/core/util/abstract/generic-component';
import { showFeedbackRemoved, showFeedbackSaved } from 'src/app/core/util/notification';
import { Globals } from 'src/app/globals';
import { DeletionModalComponent } from 'src/app/shared/components/modal/deletion-modal/deletion-modal.component';
import { Document } from '../../../../../akita/documents/state/document.model';
import { GenericMultiselectSubprojectsComponent } from 'src/app/shared/components/modal/generic-multiselect-subprojects/generic-multiselect-subprojects.component';
import { extractSharedMetadata } from 'src/app/core/util/extractSharedItemMetadata';
import { Router } from '@angular/router';

@Component({
  selector: 'app-documents-detail',
  templateUrl: './documents-detail.component.html',
  styleUrls: ['./documents-detail.component.sass'],
})
export class DocumentsDetailComponent extends GenericComponent {
  @ViewChild('genericSubproject') genericSubprojectComponent!: GenericMultiselectSubprojectsComponent;
  loaded = false;
  public isReadOnly: Boolean = false;
  public isSharedAcceptedItem: Boolean = false;
  public document:any;
  public documentId:any;
  public name:any;
  logs: Log[] = [];
  stakeholders:any[]=[];
  decisions: Decision[] = [];
  issues: Issue[] = [];
  actions: Action[] = [];
  complaints: Complaint[] = [];
  documents!: Document;
  projectConfig: any;
  entities: any
  constructor(
    public pubsub: PubsubService,
    public globals: Globals,
    public router: Router,
    private dialogRef: MatDialogRef<DocumentsDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    public dialog: MatDialog,
    private cachedService: CachedService,
    private _logsService: LogsService,
    public documentServices:DocumentsService,
    ) {
      super(globals);
  }

  ngOnInit() {
    this.isReadOnly = this.data?.shared_item_status === 'muted';
    this.cachedService.getStakeholdersRelations().subscribe(
      stakeholders => {
        this.stakeholders = stakeholders;
      }
    );
    this.name = this.data.name;
    this.document=this.data;
    this.documentId=this.data.id;
    if (!this.isReadOnly) {
      this.documentServices.getDocumentsByID(this.document.id).subscribe(((res:any)=>{
        this.documents=res;
        if ((res as any)?.shared_info && (res as any)?.shared_info?.shared_item) {
          this.isSharedAcceptedItem = this.router.url.split('/')[2].includes('sub');
          const newDoc = { ...(res as any).shared_info.shared_item };
          const { id, subprojects, ...sharedConnections } = newDoc;
          this.documents = {...sharedConnections, ...this.documents};
        }
        this.loadEntities();
      }))
    } else {
      this.documents=this.data;
      this.loaded = true;
    }
    posthog.capture('document-detail');
  }

  loadEntities(){
    forkJoin([
        this.cachedService.getContextsRelations(),
        this.cachedService.getActionsRelations(),
        this.cachedService.getIssuesRelations(),
        this.cachedService.getDecisionsRelations(),
        this.cachedService.getLogsRelations(),
        this.cachedService.getComplaintsRelations(),
        this.globals.modules && this.globals.modules.some(module => module.module_id === 'permit')
          ? this.cachedService.getPermitsRelations()
          : of([])
      ]).subscribe(([contexts, tasks, issues, requirements, contactmoments, complaints, permits]) => {
        this.entities = { contexts, tasks, issues, requirements, complaints, contactmoments: contactmoments, permits: permits }
        this.actions = tasks;
        this.logs = contactmoments;
        this.loaded = true;
      });
  }

  public updateDocument(){
    this.documentServices.updateDocument(this.documentId,this.documents).subscribe(()=>{
      showFeedbackSaved();
    })
  }

  public onSubprojectSelect(selectedSubprojects: any[]) {
    this.documents.subprojects = selectedSubprojects;
    this.updateDocument();
  }
  public deleteDocument() {
    const dialogRef = this.dialog.open(DeletionModalComponent, {
      data: 'Weet u het zeker dat u het document wilt verwijderen?'
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe((remove: boolean) => {
      if (remove) {
        this.documentServices.deleteDocument(this.documents)
          .subscribe(
            () => {
              this.close();
              showFeedbackRemoved();
            }
          );
      }
    });
  }
  public close(): void {
    this.pubsub.closeModal(this.dialogRef);
    this.pubsub.resetHistory();
  }
  public updateEntities(event){
    this.documents[event.type] = event.selected;
    this.updateDocument();
  }
  public onProjectSelection(event){
    this.documents.shared_projects = event;
    this.updateDocument();
  }
  public createDocument(event){
    const { id, shared_item_id, status, name, item_type, date, priority, source, size, type, path} = event.payload;
    const payload = { id, shared_item_id, name, item_type, date, priority, source, size, type, path };

    this.documentServices.acceptSharedDoc(status, payload).subscribe((res)=>{
      this.dialogRef.close();
    })
  }
  public onOverlayWheel(event: WheelEvent) {
    const container = document.querySelector('.popup-body');
    container?.scrollBy({ top: event.deltaY });
  }

  public scrollToBottom(){
    const el = document.querySelector('.popup-body');
    if (!el) return;

    el.scrollTo({
      top: el.scrollHeight,
      behavior: 'smooth'
    });
  }
}
